import React, { useState } from "react";
import {
  Container,
  Form,
  Button,
  Row,
  Col,
  Accordion,
  Table,
} from "react-bootstrap";
import InlineAlert from "../components/InlineAlert";
import { states, counties } from '../config/Globals';

const TeacherSearch = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [city, setCity] = useState("");
  const [instrument, setInstrument] = useState("");
  const [state, setState] = useState("");
  const [county, setCounty] = useState("");
  const [apiResult, setApiResult] = useState("");
  const [countyObject, setcountyObject] = useState({});
  const [errors, setErrors] = useState([]);

  const handleFirstNameChange = (event) => {
    setFirstName(event.target.value);
  };

  const handleLastNameChange = (event) => {
    setLastName(event.target.value);
  };

  const handleCityChange = (event) => {
    setCity(event.target.value);
  };

  const handleInstrumentChange = (event) => {
    setInstrument(event.target.value);
  };

  const handleStateChange = (event) => {
    setState(event.target.value);
    if (event.target.value !== "MD" && event.target.value !== "") {
      if (county !== "") {
        setCounty("");
      }
    }
  };

  const handleCountyChange = (event) => {
    setCounty(event.target.value);
  };

  const handleResetForm = () => {
    setFirstName("");
    setLastName("");
    setCity("");
    setInstrument("");
    setState("");
    setCounty("");
    setApiResult("");
    setErrors([]);
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    if (!firstName && !lastName && !city && !instrument && !state && !county) {
      setErrors([
        {
          errorType: "danger",
          errorMessage:
            "To perform a search, you have to fill in one of the fields below.",
        },
      ]);
      return null;
    } else {
      setErrors([]);
    }

    // console.log(`firstName: ${firstName}`);
    // console.log(`lastName: ${lastName}`);
    // console.log(`city: ${city}`);
    // console.log(`instrument: ${instrument}`);
    // console.log(`state: ${state}`);
    console.log(`county: ${county}`);

    const formData = {
      ...(firstName && { firstName: firstName }),
      ...(lastName && { lastName: lastName }),
      ...(city && { city: city }),
      ...(instrument && { instrument: instrument }),
      ...(state && { state: state }),
      ...(county && { local: county }),
    };
    const rawResponse = await fetch("/teacherSearch.php", {
      method: "POST",
      body: JSON.stringify(formData),
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Access-Control-Allow-Credentials": "true",
      },
    });

    const content = await rawResponse.text();
    var jsonContent = JSON.parse(content);
    // console.log(jsonContent);

    if ("error" in jsonContent) {
      setErrors([
        {
          errorType: "warning",
          errorMessage: "No results found! Try a different search.",
        },
      ]);
      return null;
    }
    console.log(jsonContent);
    setApiResult(jsonContent);

    var countyObjectLoc = {};
    for (const locCounty of jsonContent) {
      const sendData = {
        localbin: locCounty.localbin,
      };

      const rawLocResponse = await fetch("/localitySearch.php", {
        method: "POST",
        body: JSON.stringify(sendData),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "Access-Control-Allow-Credentials": "true",
        },
      });

      const resContent = await rawLocResponse.text();
      var jsonResContent = resContent.replace("<br>", "").replace(/"/g, "");
      console.log(jsonResContent);
      countyObjectLoc[locCounty.localbin] = jsonResContent;
    }
    setcountyObject(countyObjectLoc);
  };

  const renderStatus = (teacherStatus) => {
    if (teacherStatus === "A") {
      return "Active";
    } else if (teacherStatus === "P") {
      return "Provisional";
    } else if (teacherStatus === "C") {
      return "Collegiate";
    } else {
      return null;
    }
  };

  return (
    <Container fluid>
      <Row>
        {!apiResult && (
          <>
            <Col xs={0} md={1}></Col>
            <Col xs={12} md={10} lg={10}>
              <h2>Teacher Search</h2>
              {errors.map((error) => (
                <InlineAlert
                  key={error}
                  errorMessage={error.errorMessage}
                  variant={error.errorType}
                  closeMe={() => setErrors([])}
                />
              ))}
              <Form onSubmit={handleFormSubmit}>
                <Row className="d-flex flex-wrap">
                  <Col xs={12} md={6} lg={6}>
                    <Form.Group className="mb-3" controlId="firstName">
                      {/* <Form.Label>First Name:</Form.Label> */}
                      <Form.Control
                        type="text"
                        size="lg"
                        placeholder="First Name"
                        value={firstName}
                        onChange={handleFirstNameChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={6} lg={6}>
                    <Form.Group className="mb-3" controlId="lastName">
                      {/* <Form.Label>Last Name:</Form.Label> */}
                      <Form.Control
                        type="text"
                        size="lg"
                        placeholder="Last Name"
                        value={lastName}
                        onChange={handleLastNameChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  {/* <Col></Col> */}
                  <Col xs={12} md={4} lg={4}>
                    <Form.Group className="mb-3" controlId="instrument">
                      {/* <Form.Label className="align-items-center">Instrument:</Form.Label> */}
                      <Form.Control
                        type="text"
                        size="lg"
                        placeholder="Instrument"
                        value={instrument}
                        onChange={handleInstrumentChange}
                      />
                    </Form.Group>
                  </Col>
                  {/* <Col></Col> */}
                </Row>
                <Row>
                  <Col xs={12} md={4} lg={4}>
                    <Form.Group className="mb-3" controlId="city">
                      {/* <Form.Label>City:</Form.Label> */}
                      <Form.Control
                        type="text"
                        size="lg"
                        placeholder="City"
                        value={city}
                        onChange={handleCityChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3" controlId="state">
                      {/* <Form.Label>State:</Form.Label> */}
                      <Form.Control
                        as="select"
                        size="lg"
                        value={state}
                        onChange={handleStateChange}
                        title="Chose State"
                      >
                        {states.map((item, id) => (
                          <option key={id} value={item.value}>{item.label}</option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3" controlId="county">
                      {/* <Form.Label>County:</Form.Label> */}
                      <Form.Control
                        as="select"
                        size="lg"
                        value={county}
                        onChange={handleCountyChange}
                        disabled={
                          state === "" ? false : state !== "MD" ? true : false
                        }
                      >
                        {counties.map((item, id) => (
                          <option key={id} value={item.value}>{item.label}</option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
                
                <Row className="justify-content-center">
                  <Button
                    variant="secondary"
                    style={{ width: 230 }}
                    onClick={handleResetForm}
                    className="px-5 m-3 btn-block btn btn-lg"
                  >
                    Clear Form
                  </Button>
                  <Button
                    variant="primary"
                    style={{ width: 230 }}
                    type="submit"
                    className="px-5 m-3 btn-block btn btn-lg"
                  >
                    Find a Teacher
                  </Button>
                </Row>
              </Form>
            </Col>
            <Col xs={0} md={1}></Col>
          </>
        )}

        {apiResult && (
          <>
            <Col></Col>
            <Col xs={12} md={10}>
              <Button
                variant="outline-primary"
                className="px-5 m-3"
                onClick={handleResetForm}
              >
                Start a new Search
              </Button>
              <Accordion>
                {apiResult.map((teacher) => (
                  <Accordion.Item eventKey={teacher.ID}>
                    <Accordion.Header>
                      <Table responsive="lg" borderless>
                        <tbody>
                          <tr>
                            <td width={300}>
                              <strong>
                                {teacher.title && teacher.title + " "}
                                {teacher.fname} {teacher.midname}{" "}
                                {teacher.lname}
                              </strong>
                            </td>
                            <td>
                              <strong>{teacher.instru}</strong>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </Accordion.Header>
                    <Accordion.Body>
                      <Table responsive="lg">
                        <tbody>
                          <tr>
                            <div>
                              <a href={"mailto:" + teacher.email}>Send Email</a>
                            </div>
                          </tr>
                          <tr>
                            <td>Phone Number:</td>
                            <td>{teacher.phone}</td>
                          </tr>
                          <tr>
                            <td>Address:</td>
                            <td>
                              {teacher.addr}, {teacher.city}, {teacher.state},{" "}
                              {teacher.zip}
                            </td>
                          </tr>
                          {/* Add a sanity check to make sure the field is not empty when populated on the accordion */}
                          {teacher.localbin !== "0" && (
                            <tr>
                              <td>Located in:</td>
                              <td>{countyObject[teacher.localbin]}</td>
                            </tr>
                          )}
                          {renderStatus(teacher.mtnaStatus) && (
                            <tr>
                              <td>Membership Status:</td>
                              <td>{renderStatus(teacher.mtnaStatus)}</td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </Col>
            <Col></Col>
          </>
        )}
      </Row>
    </Container>
  );
};

export default TeacherSearch;
